'use strict';
var validate_cb_1ormore = require('../common/validate-checkables-atleastone');
var validateTextField = require('../common/validate-textfield');
var validateSelect = require('../common/validate-select');
var validateMaxLength = require('../common/validate-maxlength');
var validatePhoneNumber = require('../common/validate-phonenumber');
var pickers = require('../common/dateTimePickers.js');
var base = require('../common/base-url');
var phone_utils = require('../common/phone-utils');
var validateEmail = require('../common/validate-email');

module.exports = {
	init: function () {
		if (window.jQuery('#editProfile').length > 0) {
			toggleLT();

			if (window.jQuery('#phoneNumberValue').val() !== '') {
				validate_cb_1ormore('#phoneType');
			}

			phone_utils.setup_intl_tel_input(
				'#phoneNumber',
				'#phoneNumberValue',
				'#phoneDialCodeValue',
				'#phoneCountryCodeValue'
			);

			window.jQuery('#editEmailButton').click(editEmailModal);
			window.jQuery('#editProfile').on('click', '.dietaryCheckbox', toggleLT);

			window.jQuery('#editProfile').on('change', '#gender', toggleGenderOther);
			toggleGenderOther();

			window.jQuery('#editProfile').on('submit', validateEditProfile);
			window.jQuery('#editProfile').on('click', '.confirmCancel', function (e) {
				e.preventDefault();
				var uri = window.jQuery(this).attr('href');
				return confirmCancel(uri);
			});

			//for domestic addresses, use state dropdown; for international, use text input
			window.jQuery('#homenation').on('change', function () {
				toggleStateControl(
					window.jQuery(this),
					window.iq.domesticNationValue,
					window.jQuery(this).closest('.addressContainer')
				);
			});
			window.jQuery('#busnation').on('change', function () {
				toggleStateControl(
					window.jQuery(this),
					window.iq.domesticNationValue,
					window.jQuery(this).closest('.addressContainer')
				);
			});

			window.jQuery('.occupation').select2({ allowClear: true });
			window.jQuery('.specialty').select2({ allowClear: true });
			window.jQuery('.nation,.state-dropdown,.prefClassYear').select2();
			pickers.setupDatePicker();

			window.jQuery('.interestTags').select2({
				tags: true,
				tokenSeparators: [',']
			});
			window.jQuery('#offeringInternship').on('change', toggleInternshipInfo);
			window.jQuery('#offeringExternship').on('change', toggleExternshipInfo);
			window.jQuery('#willingToMentor').on('change', toggleMentoringInfo);

			toggleInternshipInfo();
			toggleExternshipInfo();
			toggleMentoringInfo();

			//this will only have an effect if the select UI is used. It is triggered
			//by there being >N choices, as defined in the view plugin.
			window.jQuery('.affinities-tag-ui,.regional-networks-tag-ui').select2({
				templateResult: (opt) => {
					if (opt.loading) {
						return opt;
					}
					return window.jQuery(
						`<span><strong>${opt.text}</strong><br/>${opt.element.attributes['data-descr'].value}</span>`
					);
				}
			});

			window.jQuery('.radio-btn input').on('change', function () {
				var $container = window.jQuery(this).closest('.row');

				$container.find('input').each(function () {
					var $this = window.jQuery(this);
					if ($this.prop('checked')) {
						$this.closest('.radio-btn').addClass('active');
					} else {
						$this.closest('.radio-btn').removeClass('active');
					}
				});
			});
		}
	}
};

function confirmCancel(uri) {
	if (confirm('Are you sure you want to cancel your edit?\n\nAll un-saved changes will be lost.')) {
		document.location.href = uri;
		return true;
	}
	return false;
}

function validateEditProfile() {
	var error = false;
	if (window.jQuery('#phoneNumberValue').val() !== '') {
		error = validatePhoneNumber('#phoneNumber') || error;
		error = validate_cb_1ormore('#phoneType') || error;
	}

	error = validateTextField('.requireText') || error;
	error = validateSelect('.requireSelect') || error;
	error = validateMaxLength('.checkLength') || error;
	if (error) {
		window.alert('Please make a selection in all fields marked in red');
	}
	return !error;
}

function editEmailModal() {
	var link = window.jQuery(this);
	var profileGuid = link.data('profileid');
	var url = base + '/profile/changeemail/profileGuid/' + profileGuid;
	window.jQuery('#editEmail .modal-content').load(url, function (response, status, xhr) {
		if (status === 'error') {
			window.jQuery('#editEmail .modal-content').html('There was an error loading the edit email window');
		} else {
			window.jQuery('#editEmail .modal-content').removeClass('text-align-center');
			window.jQuery('#changeEmailForm').on('submit', requestEmailChange);
		}
	});
}

function requestEmailChange(e) {
	e.preventDefault();

	// handle empty required fields
	var error = false;
	error = validateTextField('.requireText');
	if (error) {
		return false;
	}

	//handle invalid email addresses
	const $submit = window.jQuery('#changeEmailForm button[type=submit]');
	if (validateEmail('#newEmailAddress', 'emailIsValid', '#changeEmailForm', $submit)) {
		//is valid email address
		if (window.jQuery('#newEmailAddress').val() === window.jQuery('#confEmailAddress').val()) {
			isUniqueEmail(window.jQuery('#newEmailAddress').val());
		} else {
			$submit.prop('disabled', false).text('Send Verification');
			d;
			window.jQuery('#confEmailAddress').closest('.errorContainer').addClass('error');
		}
	} else {
		return false;
	}

	return false;
}

function isUniqueEmail(newEmail) {
	window.jQuery
		.ajax({
			url: base + '/profile/validateUniqueEmailAddress?emailAddress=' + encodeURIComponent(newEmail),
			contentType: 'application/json; charset=utf-8',
			type: 'POST',
			dataType: 'json'
		})
		.fail(function (jqXHR, textStatus, errorMessage) {})
		.done(function (data, textStatus, jqXHR) {
			if (data.ISUNIQUE === true) {
				makeRequest();
			} else {
				window.jQuery('#newEmailAddress').closest('.errorContainer').addClass('error');
			}
		});
}

function makeRequest() {
	window.jQuery
		.ajax({
			url: base + '/profile/requestEmailChange?' + window.jQuery('#changeEmailForm').serialize(),
			contentType: 'application/json; charset=utf-8',
			type: 'POST',
			dataType: 'json'
		})
		.fail(function (jqXHR, textStatus, errorMessage) {})
		.done(function (data, textStatus, jqXHR) {
			window.location.href = base + '/profile/emailchangerequested';
		});
}

function toggleLT() {
	var $lifeThreatening = window.jQuery('#lifeThreatening');
	var show = false;
	window.jQuery('.dietaryCheckbox:checked').each(function (ix, chk) {
		show = window.jQuery(chk).data('lifethreatening') === true || show;
	});
	if (show) {
		$lifeThreatening.removeAttr('readonly');
	} else {
		$lifeThreatening.val('').attr('readonly', 'readonly');
	}
}

function toggleInternshipInfo() {
	if (window.jQuery('#offeringInternship').is(':checked')) {
		window.jQuery('#internshipInfoDiv').show();
	} else {
		window.jQuery('#internshipInfoDiv').hide();
	}
}

function toggleExternshipInfo() {
	if (window.jQuery('#offeringExternship').is(':checked')) {
		window.jQuery('#externshipInfoDiv').show();
	} else {
		window.jQuery('#externshipInfoDiv').hide();
	}
}

function toggleGenderOther() {
	var $this = window.jQuery('#gender');
	var $selfDescription = window.jQuery('#gender_other');

	if ($this.find('option:checked').data('other')) {
		$selfDescription.removeClass('hide');
	} else {
		$selfDescription.addClass('hide');
	}
}

function toggleMentoringInfo() {
	if (window.jQuery('#willingToMentor').is(':checked')) {
		window.jQuery('.hide-not-mentoring').show();
	} else {
		window.jQuery('.hide-not-mentoring').hide();
	}
}

function toggleStateControl($nationControl, domesticValue, $addressContainer) {
	if ($nationControl.val() !== domesticValue) {
		$addressContainer.find('.showIntl').removeClass('hide').find('input,select').removeAttr('disabled');
		$addressContainer.find('.hideIntl').addClass('hide').find('input,select').attr('disabled', 'disabled');
	} else {
		$addressContainer.find('.showIntl').addClass('hide').find('input,select').attr('disabled', 'disabled');
		$addressContainer.find('.hideIntl').removeClass('hide').find('input,select').removeAttr('disabled');
	}
}
